import type { JourneyDefinition, PlanStep } from "../plan.types";

const steps: PlanStep[] = [
  {
    id: "understand",
    title: "Understand your options",
    subtitle: "Compare paths without choosing too early",
    icon: "BookOpen",
    education: {
      context:
        "Use education and care conversations to decide whether trying naturally, evaluation, insemination, or treatment fits your current needs.",
    },
    actions: [
      { label: "Explore Learn", variant: "primary", screen: "LearnScreen" },
    ],
    completionSignal: { type: "manual" },
  },
  {
    id: "history",
    title: "Add the context you have",
    subtitle: "Make future guidance more useful",
    icon: "FileText",
    education: {
      context:
        "Medical history, cycle context, partner or donor information, and prior results can shape the next conversation.",
    },
    actions: [
      {
        label: "Continue medical history",
        variant: "primary",
        screen: "MedicalHistory",
      },
    ],
    completionSignal: {
      type: "completion-percent",
      field: "medicalHistory",
      threshold: 100,
    },
  },
  {
    id: "care",
    title: "Find the right care conversation",
    subtitle: "Start with the support that fits today",
    icon: "MapPin",
    education: {
      context:
        "Find care can help you compare clinics and providers without assuming a treatment modality.",
    },
    actions: [
      { label: "Find care", variant: "primary", screen: "FindCareScreen" },
    ],
    completionSignal: { type: "external" },
  },
];

export const PREGNANCY_UNDECIDED: JourneyDefinition = {
  key: "pregnancy-undecided",
  gender: "female",
  goal: "pregnancy",
  pathway: "solo",
  title: "Pregnancy planning",
  description:
    "A neutral starting point while you decide whether to try naturally, seek evaluation, or explore treatment.",
  steps,
};
